export default __webpack_public_path__ + "static/media/diameter_icon.0c60fbc0.svg";